export default "__VITE_ASSET__8aNGvwJe__"